import { memo } from 'react';
import { TaskTodo } from 'models';
import { TaskStatusCode } from 'utils/enums';
import { customFormat, toDate } from 'utils';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  task: TaskTodo;
  handleClickItem: (task: TaskTodo) => void;
}

const TaskWidgetItem: React.FC<Props> = ({ task, handleClickItem }) => {
  const classes = useStyles();

  const list = [
    {
      label: 'Tekijä',
      value: task.Executor?.Name,
    },
    {
      label: 'Määräpäivä',
      value: customFormat(toDate(task.DueDate)),
    },
    {
      label: 'Prioriteetti',
      render: () => {
        const { Status, Priority } = task;

        return (
          <span
            className={clsx(
              classes.text,
              classes.flex,
              classes.wide,
              classes.ml5
            )}
          >
            {Priority?.Label}
            {'  '}
            <span
              className={clsx(classes.status, {
                [classes.green]: Status?.Value === TaskStatusCode.Completed,
                [classes.red]:
                  Status?.Value === TaskStatusCode.Overdue ||
                  Status?.Value === TaskStatusCode.Canceled,
              })}
            >
              {Status?.Label}
            </span>
          </span>
        );
      },
    },
  ];

  return (
    <div className={classes.root} onClick={() => handleClickItem(task)}>
      <h4 className={classes.title} title={task.Subject || ''}>
        {task.Subject}
      </h4>
      <ul className={classes.list}>
        {list.map((item) => (
          <li key={item.label} className={classes.flex}>
            <span className={classes.text}>{item.label}</span>
            {': '}
            {'  '}
            {item?.render ? (
              item.render()
            ) : (
              <span className={clsx(classes.text, classes.ml5)}>
                {item.value}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default memo(TaskWidgetItem);
